import { STACKS_COLUMN_ID } from "../constants";
import StacksTableNameCell from "./NameCell";
import StacksTableRowActionsCell from "./RowActionsCell";

export const STACKS_TABLE_CELLS = {
  [STACKS_COLUMN_ID.NAME]: StacksTableNameCell,
  [STACKS_COLUMN_ID.ROW_ACTIONS]: StacksTableRowActionsCell,
};
